import moment from "moment";
import { ContractType } from "./contract";
import { OfferTypeEnum } from "./offerType";

export interface Fee {
    id: string;
    erpId: string;
    name: string;
    type: FeeType;
    allowPurchase: boolean;
    allowSale: boolean;
    value?: number;
    sortOrder: number;
    isDefault: boolean;
    isReadOnly: boolean;
    allowedOfferTypes: OfferTypeEnum[];
    allowedContractTypes: ContractType[];
    allowedCommodities: number[];
    months: FeeMonth[];
}

export interface FeeThin {
    id: string;
    name: string;
    type: FeeType;
    value?: number;
    isDefault: boolean;
    months?: FeeMonth[];
}

export interface FeeMonth {
    month: number;
    year: number;
    value: number;
}

export function getFeeThin(f: Fee): FeeThin {
    const fee: FeeThin = {
        id: f.id,
        name: getFeeName(f.name, f.sortOrder),
        type: f.type,
        value: f.value,
        isDefault: f.isDefault,
        months: f.months
    };
    return fee;
}

function getFeeName(name?: string, sortOrder?: number): string {
    return name ?? `Fee #${sortOrder}`;
}

export enum FeeType {
    General = 1,
    Writing,
    Service,
    Freight,
    Premium,
    Roll
}

export function getFeeTypeName(type: FeeType): string {
    return FeeType[type];
}

export function getFeeValue(fee: FeeThin | Fee, date: Date | string): number {
    const dt = moment.utc(date);
    return fee.months?.find(fm => fm.month === dt.month() + 1 && fm.year === dt.year())?.value ?? fee.value
}